/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import articleImage1 from '../../../assets/images/png/article1.png';
import articleImage2 from '../../../assets/images/png/article2.png';
import articleImage3 from '../../../assets/images/png/article3.png';
import ArticleItemLists from '../../../Components/articleItemLists/ArticleItemLists';
import { SectionHeadingMed } from '../../../Components/Headings';
import './readThisNext.css';

const articlesData = [
  {
    image: articleImage1,
    drName: 'by dr. babar rashid',
    topic: 'Make the Most of Your Safer-at-Home',
    topicDesc:
      'As we face continued social distancing and safer-at-home guidelines, here are some creative ways to keep your family active..',
    btnText: 'read more'
  },
  {
    image: articleImage2,
    drName: 'by dr. babar rashid',
    topic: 'Causes and Risks of Heart Disease',
    topicDesc:
      'Coronary heart disease (CHD) is the leading cause of death among adults in the United States. Learn about the causes and risks factors..',
    btnText: 'read more'
  },
  {
    image: articleImage3,
    drName: 'by dr. babar rashid',
    topic: 'What Are the Injectable Alternatives to Statins?',
    topicDesc:
      'According to the U.S. Centers for Disease Control and PreventionTrusted Source, about 610,000 people die of heart..',
    btnText: 'read more'
  }
];

function ReadThisNext() {
  return (
    <section className="top_reads readThisNext article">
      <Container>
        <SectionHeadingMed text="READ THIS NEXT" />
        <Row>
          <Col md={9}>
            {articlesData.map((article, index) => {
              const { image, topic, topicDesc, btnText, drName } = article;
              return (
                <ArticleItemLists
                  leftCol={4}
                  rightCol={8}
                  key={index}
                  image={image}
                  drName={drName}
                  heading={topic}
                  desc={topicDesc}
                  btnText={btnText}
                />
              );
            })}
          </Col>
          <Col md={3} className="pe-lg-0">
            <div className="add">
              <h2> Ad Space </h2>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ReadThisNext;
